
const LoaderAboutMeSec = () => {
    // console.log(cvInfo)
    return (

        <div className="about-me-sec">
            <div className="row">
                <div className="col-md-6">
                    <div className="about-tx shimmerBox">
                        <h4 className="sub-title"><div className="shine shimmerLine"></div></h4>
                        <h2 className="title"><div className="shine shimmerLine"></div></h2>
                        <div className="description">
                            <div className="shine shimmerLine"></div>
                            <div className="shine shimmerLine"></div>
                            <div className="shine shimmerLine"></div>
                            <div className="shine shimmerLine"></div>
                        </div>
                        {/* <a href="#" className="btn-page ms-2">دانلود رزومه</a> */}
                        {/* <a href="#" className="btn-page btn-withe">ارتباط با ما</a> */}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="me-photo">
                        <div className="hp-inner"></div>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default LoaderAboutMeSec;